export const amenityIcons = {
  1: 'users-three',
  2: 'clock-clockwise',
  3: 'paid-parking',
  4: 'parking',
  5: 'wifi',
  7: 'paw-print',
  8: 'cooking-pot',
  9: 'waves',
  10: 'flower',
  11: 'tv',
  12: 'coffee',
  13: 'chats-circle',
  14: 'bus',
  15: 'bus-with-fee',
  16: 'lifebuoy',
  17: 'fork-knife',
  18: 'hand-palm',
  19: 'bicycle',
  20: 'sparkle',
  21: 'breakfast',
  22: 'breakfast-with-fee',
  23: 'fork-knife',
  24: 'lightning',
  25: 'hand-soap',
  26: 'bed',
  27: 'washing-machine',
  28: 'washing-machine',
  29: 'coat-hanger',
  30: 'washing-machine',
  31: 'alarm',
  32: 'flower-lotus',
  33: 'pinwheel',
  34: 'hairdryer',
  35: 't-shirt',
  36: 'lock-simple',
  37: 'smoking',
  38: 'no-smoking',
}

export const targetGroupIcons = {
  1: 'gender-female',
  2: 'gender-male',
  3: 'users-three',
}

export const roomAmenityIcons = {
  1: 'camp-fire',
  2: 'bath-tub',
  3: 'shower',
  4: 'bath-tub',
  5: 'shower',
  6: 'tv',
  7: 'cooking-pot',
  8: 'vignette',
  9: 'cooking-pot',
  10: 'cooking-pot',
  11: 'fork-knife',
  12: 'martini',
  13: 'cooking-pot',
  14: 'rectangle',
  15: 'rectangle',
  16: 'camp-fire',
  17: 'coat-hanger',
  18: 'fire-simple',
  19: 'hairdryer',
  20: 'wifi',
  21: 'wifi',
  22: 't-shirt',
  23: 't-shirt',
  24: 'washing-machine',
  25: 'martini',
  26: 'thermometer-cold',
  27: 'thermometer-cold',
  28: 'coat-hanger',
  29: 'bath-tub',
  30: 'coffee',
  31: 'cooking-pot',
  32: 'paw-print',
  33: 'wind',
  34: 'hand-soap',
  35: 'waves',
  36: 'thermometer-hot',
  37: 'lock-simple',
  38: 'bed',
  39: 'rug',
  40: 'flower',
  41: 'beer-bottle',
  42: 'bed',
  45: 'users-three',
  46: 'thermometer-hot',
  47: 'house',
}
